import {entities} from '../../../../../../../util/uiconstants';

export function mapItControlsResponse(response) {
	let itControls;
	if (response) {
		itControls = response.data.map((itControl) => {
			return {
				id: itControl.id,
				entityId: entities.ItControl,
				name: itControl.itControlName
			};
		});
	}

	return itControls;
}

export function mapTasksResponse(response) {
	let tasks;
	if (response) {
		tasks = response.taskGroups[0].tasks.map((task) => {
			return {
				id: task.id,
				entityId: entities.Task,
				name: task.taskDisplayName
			};
		});
	}

	return tasks;
}
